import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DataTable from "react-data-table-component";
import * as icons from "react-bootstrap-icons";
import { ModalBox } from "../Outer/Modal";
import Table from "react-bootstrap/Table";
import { Button, Col, Row } from "react-bootstrap";
import { CloseRounded } from "@mui/icons-material";
import Image from "react-bootstrap/Image";
import {
  AuctionGetAll,
  AuctionGetAllDataWeb,
  AuctionGetTeam,
  AuctionPlaceBid,
} from "../../redux/auth-reducer/auth-service";
import moment from "moment";
import dayjs from "dayjs";
import { ImageUrl } from "../../utils/config/config";
import { useHubEvent } from "../../hooks/useHubEvent";
import { useHubResync } from "../../hooks/useHubResync";
import { deriveAuctionStatus } from "../../utils/helper/auctionGrid";
import '../../index.css'

/**
 * #191: how long a push the list cannot read (see the ReceiveBidStatus handler) waits before the
 * page is asked for again - long enough to take the rest of the Worker's pass in one request. The
 * same as the Manager's list (Super-admin/Auction.js).
 */
const STATUS_REFETCH_DELAY_MS = 1000;

export const Admin_auction = () => {
  const [data, setData] = useState(false);
  const [showView, setShowView] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [itemListData, setitemListData] = useState([]);
  const [TeamList, setTeamList] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [auctionPlaceModal, setAuctionPlaceModal] = useState(false)
    const [auctionPlacedata, setAuctionPlaceData] = useState(null)

  function sidebarfun() {
    setData(!data);
  }
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: "Auction Name",
      selector: (row) => row?.auctionName,
      sortable: true,
    },
    {
      name: "Sports",
      selector: (row) => row?.sportName,
      sortable: true,
    },

    {
      name: "Contest",
      selector: (row) => row?.tournamentName,
      sortable: true,
    },

    {
      name: <strong>Auction Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },
    {
      name: "Team Bidding Open",
      selector: (row) => row?.status,
      sortable: true,
    },
    {
      name: "Teams",
      selector: (row) => (
        <>
          <button className="tablebtn viewButton" onClick={() => viewFn(row)}>
            <RemoveRedEyeOutlinedIcon />
            Team
          </button>
        </>
      ),
    },
    // show Auction data 
    {
      name: "Auction Winnings",
      selector: (row) => (
        <>
          <button className="tablebtn viewButton" onClick={() => viewPlacebit(row)}>
            <RemoveRedEyeOutlinedIcon />
          </button>
        </>
      ),
    },

    {
      name: "Created By",
      selector: (row) => <>{row?.createdByName}</>,
    },
    // {
    //   name: 'Action',
    //   selector: (row) => (
    //     <>
    //       <button type='button' className='text-danger btn-aucion' ><icons.Trash /></button>
    //     </>),
    //   sortable: true,
    // },
  ];

  const GetTeamList = async (id) => {
    await AuctionGetTeam(id).then((response) => {
      setTeamList(response?.data);
    });
  };

  const getAllAuction = async (data) => {
    try {
      const response = await AuctionGetAllDataWeb(data); // Call your API function
      if (response?.data) {
        setitemListData(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    getAllAuction(data); // Fetch data when currentPage changes
  }, [currentPage]); // Dependency on currentPage

  // #191: statuses pushed while the live connection was down are lost; reload the page.
  useHubResync(() => {
    getAllAuction({ PageNumber: currentPage, PageSize: perPage, SortOrder: false });
  });

  // What a refetch started later - from the timer below - must read: the page as it is then.
  const pageQueryRef = useRef(null);
  pageQueryRef.current = { PageNumber: currentPage, PageSize: perPage, SortOrder: false };
  const statusRefetchRef = useRef(null);

  useEffect(() => {
    const statusRefetch = statusRefetchRef;
    return () => clearTimeout(statusRefetch.current);
  }, []);

  // #191 reopen: the Worker's push of every unfinished team (and of a team it has just closed), as
  // on the Manager's list (Super-admin/Auction.js). This list had no live updates at all, so an
  // auction stayed Live here after its last lot closed until the page was reloaded. Each auction's
  // status is derived from all of its pushed rows at once (deriveAuctionStatus) and written only
  // when it differs, only for the auctions on this page.
  useHubEvent("ReceiveBidStatus", (pushed) => {
    if (!Array.isArray(pushed)) return;

    const rowsByAuction = new Map();
    pushed.forEach((row) => {
      const rows = rowsByAuction.get(row?.auctionId) || [];
      rows.push(row);
      rowsByAuction.set(row?.auctionId, rows);
    });
    const derived = new Map(
      [...rowsByAuction].map(([auctionId, rows]) => [auctionId, deriveAuctionStatus(rows)])
    );

    setitemListData((prev) => {
      if (!Array.isArray(prev)) return prev;
      let changed = false;
      const next = prev.map((item) => {
        const status = derived.get(item.auctionId);
        if (!status || status === item.status) return item;
        changed = true;
        return { ...item, status };
      });
      return changed ? next : prev;
    });

    // A mix the push cannot read - a team just closed and none live, or all closed - for an auction
    // shown Live or Paused means it may have ended: ask the server, once for the whole pass.
    const shown = Array.isArray(itemListData) ? itemListData : [];
    const unreadable = shown.some(
      (item) =>
        derived.has(item.auctionId) &&
        derived.get(item.auctionId) === null &&
        (item.status === "Live" || item.status === "Paused")
    );
    if (unreadable && !statusRefetchRef.current) {
      statusRefetchRef.current = setTimeout(() => {
        statusRefetchRef.current = null;
        getAllAuction(pageQueryRef.current);
      }, STATUS_REFETCH_DELAY_MS);
    }
  });

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    getAllAuction(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const viewFn = (viewItem) => {
    GetTeamList(viewItem.auctionId);
    setShowView(true);
  };

const viewPlacebit = async(item) => {
    const autionId  = item.auctionId
    const result = await AuctionPlaceBid(autionId)
    setAuctionPlaceData(result?.data)
    if(result){
      setAuctionPlaceModal(true)
    }
  }

  const handleAuctionPalceBitClosed = () => {
    setAuctionPlaceModal(false)
  }


  const handleClosed = () => {
    setShowView(false);
    setTeamList([]);
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const filteredData = searchText
    ? itemListData?.filter((item) => {
        // The rows' field is auctionName (camelCase, like every API row); this read AuctionName,
        // which is undefined, so any search text emptied the table.
        return item?.auctionName?.toLowerCase().includes(
          searchText?.toLowerCase()
        );
      })
    : itemListData;
  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <div className="dasboard-group">
        <TopNavbar sidebarfun={sidebarfun} />
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Auction</h1>
          <div className="group_data_table admin">
            <div className="search-input filter d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>

            {/* <DataTable
              title="dfsfd"
              columns={columns}
              data={filteredData}
              pagination
              className='p-3'
              paginationPerPage={10}
              paginationRowsPerPageOptions={[ 10, 15, 20]}
              paginationTotalRows={filteredData?.length}
            /> */}
            <div>
              <DataTable
                title="Auction List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <>
                        <label>Rows per page: </label>{" "}
                        <select
                          id="itemsPerPage"
                          value={perPage}
                          onChange={handlePerPageChange}
                        >
                          {pageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>

      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">Teams</h1>
          </>
        }
        body={
          <>
            <Table bordered hover className="table-team border">
              <thead>
                <tr>
                  <th>Logo</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {TeamList.map((e) => {
                  return (
                    <tr>
                      <td>
                        <Image
                          src={
                            e.teamImage
                              ? ImageUrl + e.teamImage
                              : "/image/team-icon.png"
                          }
                          width={30}
                        />
                      </td>
                      <td>{e.teamName}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        }
        footer={
          <>
            <Button variant="secondary close-btn" onClick={handleClosed}>
              <CloseRounded />
            </Button>
          </>
        }
      />

      <ModalBox
        show={auctionPlaceModal}
        dialogClassName="custom-modal" 
        headerClassName="custom-modal-header"
        title={
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h1 className="heading-dash text-left">
                  Auction Winnings
                </h1>
              </div>

              <div className="col-md-8">
                <div className="row justify-content-between">
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Total Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.totalPool || 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Manager Hold
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(`${auctionPlacedata?.[0]?.xcuttaTake}%` || 0)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Net Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.netPool || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        body={
          <div className="row">
            {/* Left Side Information */}
            {/* <div className="col-4" style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}>
              <div className="mb-3">
                <strong>Auction Pool:</strong> 
                <span className="float-right">
                  {(auctionPlacedata?.[0]?.totalPool || 0).toFixed(2)}
                </span>
              </div>
              <div className="mb-3">
                <strong>Manager Hold:</strong> 
                <span className="float-right">
                  {(auctionPlacedata?.[0]?.managerHold || 0).toFixed(2)}
                </span>
              </div>
              <div className="mb-3">
                <strong>Net Pool:</strong> 
                <span className="float-right">
                  {((auctionPlacedata?.[0]?.totalPool || 0) - (auctionPlacedata?.[0]?.managerHold || 0)).toFixed(2)}
                </span>
              </div>
            </div> */}

            {/* Right Side Table */}
            {/* <div className="col-8"> */}
            <Table bordered>
              <thead>
                <tr>
                  {[
                    "Winner Title",
                    "Winner Percentage",
                    "Winner Amount"
                  ].map((header, index) => (
                    <th
                      key={index}
                      className="bg-gray-view"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {auctionPlacedata?.map((item, index) => (
                  <tr key={index} style={{ textAlign: 'center' }}>
                    <td>
                      {item?.winnerTitle}
                    </td>
                    <td>
                      {`${item?.winnerPercentage}%`}
                    </td>
                    <td>
                      {(item?.winningAmount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* </div> */}
          </div>
        }
        footer={
          <Button variant="secondary" onClick={handleAuctionPalceBitClosed}>
            Close
          </Button>
        }
      />
    </>
  );
};
